import React from 'react';
import classNames from 'classnames';

import {Props} from './types';
import {Card, Layouts} from '@components';
import constants from '@constants';

import './index.scss';

const Main: React.FC<Props> = props => {
  const isAuthed = props.me.sub;
  return (
    <>
      <div className={classNames('a__price', {'is-authed': !!isAuthed})}>
        {!isAuthed && (
          <Layouts.Header.Before
            history={props.history}
            location={props.location}
            match={props.match}
          />
        )}
        <div className={classNames('b__title', {'is-authed': !!isAuthed})}>
          プラン
        </div>
        <div className={classNames('w__cards', {'is-authed': !!isAuthed})}>
          <div className={classNames('b__card-main', {before: !isAuthed})}>
            <div className="w__price-cards">
              <Card.Price
                option={constants.PLAN.FREE}
                history={props.history}
                me={props.me}
              />
              <Card.Price
                option={constants.PLAN.SAFETY}
                history={props.history}
                className="center"
                me={props.me}
              />
              <Card.Price
                option={constants.PLAN.SAFETY_X}
                history={props.history}
                me={props.me}
              />
            </div>
          </div>
        </div>
        {!isAuthed && <Layouts.Footer.Main />}
      </div>
    </>
  );
};

export default Main;
